import { render } from "./formshow.vue?vue&type=template&id=0b961042&scoped=true"
import script from "./formshow.vue?vue&type=script&lang=js"
export * from "./formshow.vue?vue&type=script&lang=js"

import "./formshow.vue?vue&type=style&index=0&id=0b961042&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b961042"]])

export default __exports__